
const swiperHero = new Swiper('.co-events-s1--slider', {
  // Default parameters
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  pagination: {
    el: '.co-events-s1--slider .swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  autoplay: {
   delay: 3500,
 },
})

const swiperTestimonials = new Swiper('.co-events-s3--slider', {
  // Default parameters
  slidesPerView: 'auto',
  spaceBetween: 4,
  loop: true,
  navigation: {
    nextEl: '.co-events-s3--next',
    prevEl: '.co-events-s3--prev',
  },
})